import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { FeedActivityItem } from '@components/Feed/Activities/FeedActivityItem';
import { CommentButtonAction, PostActionButtons } from '@components/Feed/Post/ActionButtons';
import type { FeedPostActionsInfoFragmentDoc, FragmentType } from '@graphql/reactQuery';
import { ArtistDropReleaseFragmentDoc, getFragment } from '@graphql/reactQuery';
import { FeedReleaseCard } from './FeedReleaseCard';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ArtistDropRelease on Release {
    id
    artist {
      id
      user {
        id
        ...UserActivityDetail
      }
    }
    ...FeedReleaseCard
  }
`);

export const ArtistDrop = ({
  releaseFrag,
  postActionsFrag,
  timeStamp,
}: {
  releaseFrag: FragmentType<ArtistDropReleaseFragmentDoc>;
  postActionsFrag?: FragmentType<FeedPostActionsInfoFragmentDoc> | null;
  timeStamp: number;
}) => {
  const release = getFragment(ArtistDropReleaseFragmentDoc, releaseFrag);
  const { artist } = release;

  return (
    <FeedActivityItem
      dropdownContent={null}
      userFrag={artist.user}
      description="Dropped a song"
      timestamp={timeStamp}
    >
      <FeedReleaseCard releaseFrag={release} />

      {postActionsFrag && (
        <div className="my-3">
          <PostActionButtons
            commentButtonAction={CommentButtonAction.ShowModal}
            postFrag={postActionsFrag}
            sourceLocation="Artist Drop Card"
            releasePostArtistTwitterHandle={null}
          />
        </div>
      )}
    </FeedActivityItem>
  );
};
